export enum ContentType {
  ALL = 'all',
  BRAND_REVIEW = 'brand_review',
  SINGLE_REVIEW_PRODUCT = 'single_review_product',
  REVIEW_GUIDE = 'review_guide',
}
